module.exports = __webpack_public_path__ + "static/img/shop_top.7e4d315.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop_top.jpeg
// module id = 253
// module chunks = 1